// extracted by mini-css-extract-plugin
export default {"main_container":"styles_main_container__fe2N8"};